import React, { memo } from 'react';
import styled from '@emotion/styled';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { flattenGroupsIntoLinks } from '../NavigationDrawer.helpers';
const SSRNavigationDrawer = memo(({ groups, ...props }) => {
    const flattenedLinks = groups === null || groups === void 0 ? void 0 : groups.map((link) => {
        const dataProps = {
            ...link,
            // @ts-ignore
            links: link.groups && flattenGroupsIntoLinks(link.groups),
        };
        return dataProps;
    });
    return (React.createElement(Container, { "aria-hidden": true, role: "navigation", ...props, "data-type": 'navigation-list-ssr' },
        React.createElement("ul", null, flattenedLinks === null || flattenedLinks === void 0 ? void 0 : flattenedLinks.map((item, index) => (React.createElement(NavigationItem, { key: index, ...item, onClick: item.onClick }))))));
});
SSRNavigationDrawer.displayName = 'SSRNavigationDrawer';
export default SSRNavigationDrawer;
const NavigationItem = ({ links, label, path, ...item }) => {
    const MainElement = !!(item === null || item === void 0 ? void 0 : item.href) ? 'a' : 'span';
    // ensure that links are not tab-able when hidden
    const tabIndexProps = !!(item === null || item === void 0 ? void 0 : item.href) ? { tabIndex: -1 } : {};
    const href = item === null || item === void 0 ? void 0 : item.href;
    return (React.createElement("li", null,
        React.createElement(MainElement, { id: path, href: href, ...tabIndexProps }, label),
        !!(links === null || links === void 0 ? void 0 : links.length) && (React.createElement(SubContainer, { "aria-labelledby": `nav${path}` }, links.map((item, index) => (React.createElement(NavigationItem, { key: index, onClick: item === null || item === void 0 ? void 0 : item.onClick, label: item === null || item === void 0 ? void 0 : item.label, eventLabel: item === null || item === void 0 ? void 0 : item.eventLabel, links: item.groups ? flattenGroupsIntoLinks(item.groups) : item.links, path: item === null || item === void 0 ? void 0 : item.path, href: item === null || item === void 0 ? void 0 : item.href })))))));
};
const Container = styled.nav `
  position: fixed;
  pointer-events: none;
  width: 1px;
  height: 1px;
  overflow: hidden;
  transform: translateX(-100vw);
`;
const SubContainer = styled.ul `
  margin-inline-start: ${Spacings.xLarge};
`;
